"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
var _Button = require("../../../components/Button");
var _TextInput = require("../../../components/TextInput");
var _endpoints = require("../../../utils/endpoints");
var _price = require("../../../utils/price.utils");
var _toast = require("../../../utils/toast");
var _useFormInvalid = require("../../../utils/useFormInvalid");
var _useRequest2 = require("../../../utils/useRequest");
var _validators = require("../../../utils/validators");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var EditBookingClinicianRateForm = function EditBookingClinicianRateForm(_ref) {
  var form = _ref.form,
    booking = _ref.booking,
    _onSuccess = _ref.onSuccess;
  var validateFieldsAndScroll = form.validateFieldsAndScroll,
    getFieldValue = form.getFieldValue,
    getFieldDecorator = form.getFieldDecorator;
  var _useRequest = (0, _useRequest2.useRequest)(function (data) {
      return {
        url: (0, _endpoints.getUpdateAppointmentClinicianRateUrl)(booking.id, booking.patient.id),
        method: 'patch',
        data: data
      };
    }, {
      manual: true,
      onSuccess: function onSuccess() {
        _toast.toast.success({
          title: 'Clinician rate for booking updated successfully!'
        });
        _onSuccess();
      }
    }),
    updateBookingClinicianRate = _useRequest.run;
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    validateFieldsAndScroll(function (err, values) {
      if (err) {
        return;
      }
      if (!values.clinicianRate) {
        return;
      }
      var clinicianRate = (0, _price.parsePriceFormStringToNum)(values.clinicianRate);
      updateBookingClinicianRate({
        clinicianRate: clinicianRate
      });
    });
  };
  var formInvalid = (0, _useFormInvalid.useFormInvalid)(form);
  var clinicianRate = getFieldValue('clinicianRate');
  var submitDisabled = formInvalid || !clinicianRate;
  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Clinician Rate"
  }, /*#__PURE__*/_react.default.createElement("div", null, "(auto-populated from provider rate, after the session ends)"), getFieldDecorator('clinicianRate', {
    initialValue: (0, _price.parsePriceNumToFormString)(booking.clinicianRate),
    rules: [{
      validator: (0, _validators.priceValidator)()
    }]
  })( /*#__PURE__*/_react.default.createElement(_TextInput.TextInput, {
    placeholder: "0.00",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-center my-[20px]"
  }, /*#__PURE__*/_react.default.createElement(_Button.PrimaryButton, {
    size: "small",
    htmlType: "submit",
    disabled: submitDisabled
  }, "Update clinician rate")));
};
var _default = _form.default.create({
  name: 'EditBookingClinicianRateForm'
})(EditBookingClinicianRateForm);
exports.default = _default;